import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { ZuiMaterialFormStackModule } from '@zerops/zui/material-form-stack';
import { ZefFormFieldModule, NgrxFormsExtensionsModule } from '@zerops/zef/forms/modules';
import { NgrxFormsModule } from 'ngrx-forms';
import { UserInfoFieldsComponent } from './user-info-fields.component';
import { UserInfoFieldsTranslationsModule } from './user-info-fields.translations';

@NgModule({
  declarations: [ UserInfoFieldsComponent ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ZuiMaterialFormStackModule,
    ZefFormFieldModule,
    NgrxFormsModule,
    NgrxFormsExtensionsModule,
    UserInfoFieldsTranslationsModule
  ],
  exports: [ UserInfoFieldsComponent ]
})
export class UserInfoFieldsModule {

}
